import { SAVE_USER } from "./users.types";

export const saveUser = (user) => {
    return {
      type: SAVE_USER,
      payload: user,
    };
  };